import { AgGridReact } from "ag-grid-react";
import { inject, observer } from 'mobx-react';
import React from "react";
import { withRouter } from "react-router-dom";
import { Calendar, Share2, Edit, Plus, Menu, Search, Star, ChevronLeft, ChevronRight } from "react-feather";
import { Link } from "react-router-dom";
import {
  Button, Card, CardHeader, CardTitle, CardBody, CardFooter, Col, DropdownItem, DropdownMenu,
  DropdownToggle, Input, Row, UncontrolledDropdown, FormGroup, Modal, Pagination, PaginationItem, PaginationLink
} from "reactstrap";
import "../../assets/scss/pages/users.scss";
import "../../assets/scss/plugins/tables/_agGridStyleOverride.scss";
import profileImg from "../../assets/img/profile/placeholder.svg";
import * as ROUTES from '../../constants/routes';
import classnames from "classnames";
import ScheduleMeetingWizard from "../calendar/components/ScheduleMeetingWizard";
import ContentSelector from "../elements/contentSelector";
import PaginatorComp from "../common/PaginatorComp";
import SearchBar from "../common/elements/searchBar";
import CustomerStore from "../../stores/customerStore";
import { NoDataComp, LoadingComp } from "../common/elements/FunctionalComp";
import { CustomerCard } from "./components/CustomerCard";
import ICustomer from "../../types/ICustomer";

interface ICustomerPageProps {
  hasAddNewFunctionality: boolean,
  toggle: any,
  contentSharing: string,
  libraryStore?: any,
  createMeetingStore: any,
  sessionStore: any,
  customerStore: CustomerStore,
  mainSidebar: any,
  sidebar: any,
  history: any
}

interface ICustomerPageState {
  selectedCustomer: any,
  customerData: any,
  pageSize: number,
  isVisible: boolean,
  reload: boolean,
  collapse: boolean,
  status: string,
  role: string,
  selectStatus: string,
  verified: string,
  department: string,
  defaultColDef: any,
  searchVal: string,
  showModal: boolean,
  meetingSliderVisibility: boolean
}

@inject('customerStore', 'createMeetingStore', 'sessionStore', 'libraryStore')
@observer
class CustomerPage extends React.Component<ICustomerPageProps, ICustomerPageState> {

  state = {
    showModal: false,
    meetingSliderVisibility: false,
    selectedCustomer: null,
    customerData: null,
    pageSize: 20,
    isVisible: true,
    reload: false,
    collapse: true,
    status: "Opened",
    role: "All",
    selectStatus: "All",
    verified: "All",
    department: "All",
    searchVal: "",
    defaultColDef: {
      sortable: true
    },
  }
  gridApi: any;
  gridColumnApi: any;

  async componentDidMount() {
    this.onListenForCustomers();
    this.props.sessionStore.setContentSharing("customer");
  }

  componentDidUpdate(props: any) {
    /*if (props.customerStore.limit !== this.props.customerStore.limit) {
      this.onListenForCustomers();
    }*/
  }

  onListenForCustomers = () => {
    this.props.customerStore.loadCustomers();
  };

  navigateTo = (goto: string) => {
    this.props.history.push(goto)
  }


  selectCustomer = (cust: any, contentSharing: any) => {
    if (contentSharing === "meeting") {
      const { createMeetingStore } = this.props;
      createMeetingStore.setCustomer(cust)
      this.props.toggle();
    } else if (contentSharing === "library" || "customer" ){
      const { libraryStore } = this.props;
      libraryStore.setCustomer(cust);
      this.props.toggle();
    }
  }

  toggleModal = (cust: any) => {
    this.setState(prevState => ({
      showModal: !prevState.showModal
    }),()=>{
      if(this.state.showModal) {
        this.props.customerStore.loadCustomer(cust.uid)
      }
    })
  }

  toggleMeetingSlider = (cust:any) => {
    if(cust) {
      this.setState(prevState => ({
        selectedCustomer: cust,
        meetingSliderVisibility: !prevState.meetingSliderVisibility
      }))
    } else {
      this.setState(prevState => ({
        meetingSliderVisibility: !prevState.meetingSliderVisibility
      }))
    }
  }

  onCreateSuccess = () => {
    this.setState({ meetingSliderVisibility: false });
  }

  onGridReady = async (params: any) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi
  }

  filterData = (column: any, val: any) => {
    var filter = this.gridApi.getFilterInstance(column)
    var modelObj = null
    if (val !== "all") {
      modelObj = {
        type: "equals",
        filter: val
      }
    }
    filter.setModel(modelObj)
    this.gridApi.onFilterChanged()
  }

  filterSize = (val: any) => {
    if (this.gridApi) {
      this.gridApi.paginationSetPageSize(Number(val))
      this.setState({
        pageSize: val
      })
    }
  }

  onNext = (n:number) => {
    const { customerStore } = this.props;
    customerStore.setPaginator({ pageNumber: n });
    customerStore.loadCustomers();
  }

  onPrev = (n:number) => {
    const { customerStore } = this.props;
    customerStore.setPaginator({ pageNumber: n });
    customerStore.loadCustomers();
  }

  goToPage = (n:number) => {
    const { customerStore } = this.props;
    customerStore.setPaginator({ pageNumber: n });
    customerStore.loadCustomers();
  }

  updateSearchQuery = (e: any) => {
    const { customerStore } = this.props;
    const val = e.target.value;
    customerStore.setCustomerFilter({ searchTerm: val })
    if (val && val.length > 3)
    customerStore.loadCustomers();
  }

  clearSearchQuery = () => {
    const { customerStore } = this.props;
    debugger;
    customerStore.setCustomerFilter({searchTerm: ''})
  }

  refreshCard = () => {
    this.setState({ reload: true })
    setTimeout(() => {
      this.setState({
        reload: false,
        role: "All",
        selectStatus: "All",
        verified: "All",
        department: "All"
      })
    }, 500)
  }

  toggleCollapse = () => {
    this.setState(state => ({ collapse: !state.collapse }))
  }
  onEntered = () => {
    this.setState({ status: "Opened" })
  }
  onEntering = () => {
    this.setState({ status: "Opening..." })
  }
  onExiting = () => {
    this.setState({ status: "Closing..." })
  }
  onExited = () => {
    this.setState({ status: "Closed" })
  }
  removeCard = () => {
    this.setState({ isVisible: false })
  }

  render() {
    const {  defaultColDef, pageSize } = this.state
    const { customerStore } = this.props;
    const { customerCollection, customerPaginator, customerFilter, screen } = customerStore;
    const { customers } = customerCollection;
    const { list } = screen;

    const noData = (
      <div className="loading_conatiner">
        <div className="">
          <div>No Customers to Show</div>
        </div>
      </div>
    );
    
    const loading = <LoadingComp />

    const paginatorComp = <div className="text-center">
      <PaginatorComp paginator={customerPaginator}
        onNext={this.onNext}
        onPrev={this.onPrev}
        goToPage={this.goToPage} />
    </div>

    const modal = (<Modal
      isOpen={this.state.showModal}
      toggle={this.toggleModal}
      className="modal-dialog-centered modal-xl"
    >
      <div className="sidebar_header">
        <h3 className="heading">Select Content</h3>
        <div>
          <Button
            color="danger"
            outline
            className="btn ml-1"
            onClick={this.toggleModal}
          >
            Cancel
            </Button>
        </div>
      </div>
      <div className="sidebar_content">
        <ContentSelector
          contentSharing="customer"
          toggle={this.toggleModal}
        />
      </div>
    </Modal>)

    const custCards = <div id="_library-products" className="grid-view">
    {customers && customers.length > 0
    ? customers.map((cust: any)=> {
      return <CustomerCard customer={cust} 
                      hasAddNewFunctionality={this.props.hasAddNewFunctionality}
                      key={cust.uid}
                      onShareClick={(cust:ICustomer)=>{this.toggleModal(cust)}}
                      onCalendarClick={(cust:ICustomer)=>{this.toggleMeetingSlider(cust)}}
                      onSelectCustomer={(cust:ICustomer)=>{this.selectCustomer(cust, this.props.contentSharing) }}
                />
    }) : noData}
    </div>;

    const headerCol = <div className="_library-header-items">
        <div className="library-sidebar-toggler d-block d-lg-none">
          <Menu
            size={26}
            onClick={() => this.props.mainSidebar(!this.props.sidebar)}
          />
      </div>
      <div className="d-flex justify-content-between align-items-center" style={{width: "100%"}}>
        <SearchBar value={customerFilter.searchTerm} 
                   onChange={(e)=>this.updateSearchQuery(e)}
                   onReset={()=> this.clearSearchQuery()}/>
        {
          this.props.hasAddNewFunctionality
            ?<Link to={ROUTES.CUSTOMER_CREATE} >
              <Button
                className="btn ml-20"
                color="primary">
                <Plus size={15} />
                <span className="align-middle">&nbsp;Add</span>
              </Button>
            </Link>
          : null
        }                    
      </div>
    </div>;

    return (
      <div className="library-content">
        <div className='data-list'>
          <Row>
            <Col sm="12">
              { headerCol }
            </Col>
            <Col sm="12" className="mt-2">
              {
                  list.isLoading ? loading :
                    <React.Fragment>
                      { custCards }
                      { paginatorComp }
                    </React.Fragment>
                }
            </Col>
          </Row>
        </div>


        {modal}
        <div className="animation-slider">
          {
            this.state.meetingSliderVisibility
              ? <ScheduleMeetingWizard
                show={this.state.meetingSliderVisibility}
                onCreateSuccess={this.onCreateSuccess}
                toggleSliderVisibility={this.toggleMeetingSlider}
                createMeetingStore={this.props.createMeetingStore}
                sessionStore={this.props.sessionStore}
                meetingId=""
                customer={this.state.selectedCustomer}
              />
              : null
          }
          <div
            className={classnames("animation-slider-overlay", {
              show: this.state.meetingSliderVisibility
            })}
            onClick={() => this.toggleMeetingSlider(null)}
          />
        </div> 
      </div> 
    )
  }
}

export default CustomerPage;


{/* {rowData !== null ? (
  <AgGridReact
    gridOptions={{}}
    rowSelection="multiple"
    defaultColDef={defaultColDef}
    columnDefs={columnDefs}
    rowData={rowData}
    onGridReady={this.onGridReady}
    colResizeDefault={"shift"}
    animateRows={true}
    floatingFilter={false}
    pagination={true}
    pivotPanelShow="always"
    paginationPageSize={pageSize}
  />
) : null} */}